import React, { useRef, useEffect } from 'react';

interface Props {
  onClick: () => void;
}

const InteractionExitButton: React.FC<Props> = ({ onClick }) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Show the popover when component mounts
    if (popoverRef.current && 'showPopover' in popoverRef.current) {
      popoverRef.current.showPopover();
    }

    // Cleanup: hide popover when component unmounts
    return () => {
      if (popoverRef.current && 'hidePopover' in popoverRef.current) {
        popoverRef.current.hidePopover();
      }
    };
  }, []);

  return (
    <div
      ref={popoverRef}
      popover='manual'
      style={{
        position: 'fixed',
        top: 'auto',
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        margin: 0,
        background: 'transparent',
        border: 'none',
        pointerEvents: 'auto',
        cursor: 'pointer',
        fontSize: '14px',
      }}
    >
      <aha-pill
        onClick={onClick}
        color={'var(--theme-inverted-background)'}
        text-color={'var(--theme-inverted-primary-text)'}
      >
        Stop interacting with the view
      </aha-pill>
    </div>
  );
};

export default InteractionExitButton;
